export default __webpack_public_path__ + "static/howto-4-313862aa548d234d3d0ac1cb32b66c8b.png";